 //override bootstrap table cellspacing for legacy tables :'(
 	$(function () {
        $('.xs-legacy-content table[cellspacing]').each(function() {
           var space = $(this).attr('cellspacing') + 'px';
           $(this).css('border-spacing', space);
           $(this).css('border-collapse', 'separate');
        });
    });